import React from 'react'
import { Router, Route, Redirect, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import { history, BaseURL } from './helpers'
import { alertActions } from './actions'
import { PrivateRoute } from './components/PrivateRoute'

import MainLayout from './components/MainLayout'
// import LoginPage from './Pages/LoginPage'
// import Home from './Pages/HomePage'
// import OrganizationPage from './Pages/OrganizationPage'
// import OrganizationDetailPage from './Pages/OrganizationDetailPage'
// import OrganizationBalanceHistory from './Pages/OrganizationBalanceHistory'
// import Register from './Pages/RegisterPage'
// import RegisterStatusPage from './Pages/RegisterStatusPage'
// import ListCustomer from './Pages/ListCustomer'
// import BalanceHistory from './Pages/BalanceHistory'
// import Profile from './Pages/Profile'
// import RegisterDocument from './Pages/RegisterDocument'
// import CustomerDetail from './Pages/CustomerDetail'
// import VerifyToken from './Pages/VerifyToken'
// import RegisterDocumentCorporation from './Pages/RegisterDocumentCorporation'
// import CorporationBookCustomerPage from './Pages/CorporationBookCustomerPage'

import LoadingComponent from './components/shared/LoadingComponent'
import './style/css/global.css'
import Loadable from 'react-loadable'

const LoginPage = Loadable({
	loader: () => import(/* webpackChunkName: "LoginPage" */ './Pages/LoginPage'),
	delay: 500,
	loading: LoadingComponent,
})
const Home = Loadable({
	loader: () => import(/* webpackChunkName: "HomePage" */ './Pages/HomePage'),
	delay: 500,
	loading: LoadingComponent,
})
const OrganizationPage = Loadable({
	loader: () => import(/* webpackChunkName: "OrganizationPage" */ './Pages/OrganizationPage'),
	loading: LoadingComponent,
	delay: 500,
})
const OrganizationDetailPage = Loadable({
	loader: () => import(/* webpackChunkName: "OrganizationDetailPage" */ './Pages/OrganizationDetailPage'),
	loading: LoadingComponent,
	delay: 500,
})
const OrganizationBalanceHistory = Loadable({
	loader: () => import(/* webpackChunkName: "OrganizationBalanceHistory" */ './Pages/OrganizationBalanceHistory'),
	loading: LoadingComponent,
	delay: 500,
})
const Register = Loadable({
	loader: () => import(/* webpackChunkName: "RegisterPage" */ './Pages/RegisterPage'),
	loading: LoadingComponent,
	delay: 500,
})
const RegisterStatusPage = Loadable({
	loader: () => import(/* webpackChunkName: "RegisterStatusPage" */ './Pages/RegisterStatusPage'),
	loading: LoadingComponent,
	delay: 500,
})
const ListCustomer = Loadable({
	loader: () => import(/* webpackChunkName: "ListCustomer" */ './Pages/ListCustomer'),
	loading: LoadingComponent,
	delay: 500,
})
const BalanceHistory = Loadable({
	loader: () => import(/* webpackChunkName: "BalanceHistory" */ './Pages/BalanceHistory'),
	loading: LoadingComponent,
	delay: 500,
})
const Profile = Loadable({
	loader: () => import(/* webpackChunkName: "Profile" */ './Pages/Profile'),
	loading: LoadingComponent,
	delay: 500,
})
const RegisterDocument = Loadable({
	loader: () => import(/* webpackChunkName: "RegisterDocument" */ './Pages/RegisterDocument'),
	loading: LoadingComponent,
	delay: 500,
})
const CustomerDetail = Loadable({
	loader: () => import(/* webpackChunkName: "CustomerDetail" */ './Pages/CustomerDetail'),
	loading: LoadingComponent,
	delay: 500,
})
const VerifyToken = Loadable({
	loader: () => import(/* webpackChunkName: "VerifyToken" */ './Pages/VerifyToken'),
	loading: LoadingComponent,
	delay: 500,
})
const RegisterDocumentCorporation = Loadable({
	loader: () => import(/* webpackChunkName: "RegisterDocumentCorporation" */ './Pages/RegisterDocumentCorporation'),
	loading: LoadingComponent,
	delay: 500,
})
const CorporationBookCustomerPage = Loadable({
	loader: () => import(/* webpackChunkName: "CorporationBookCustomerPage" */ './Pages/CorporationBookCustomerPage'),
	delay: 500,
	loading: LoadingComponent,
})

class App extends React.Component {
	constructor(props) {
		super(props)

		const { dispatch } = this.props
		history.listen((location, action) => {
			// clear alert on location change
			dispatch(alertActions.clear())
		})
	}

	render() {
		const { alert } = this.props
		return (
			<Router history={history}>
				<MainLayout>
					{alert.message && <div className={`alert ${alert.type}`}>{alert.message}</div>}

					<Switch>
						<PrivateRoute exact path={`${BaseURL}/`} component={Home} auth />
						<Route path={`${BaseURL}/login`} component={LoginPage} />
						<Route path={`${BaseURL}/register`} component={Register} />
						<Route path={`${BaseURL}/register-status/:token`} component={RegisterStatusPage} />
						<Route path={`${BaseURL}/register-document/:id`} component={RegisterDocument} />
						<Route path={`${BaseURL}/book/:code`} component={CorporationBookCustomerPage} />
						<Route
							path={`${BaseURL}/register-document-corporation/:id`}
							component={RegisterDocumentCorporation}
						/>
						<Route path={`${BaseURL}/verify`} component={VerifyToken} />

						<PrivateRoute path={`${BaseURL}/balance`} component={BalanceHistory} auth />

						<PrivateRoute path={`${BaseURL}/organization`} component={OrganizationPage} auth />
						<PrivateRoute
							path={`${BaseURL}/organization-detail/:id`}
							component={OrganizationDetailPage}
							auth
						/>
						<PrivateRoute
							path={`${BaseURL}/organization-balance`}
							component={OrganizationBalanceHistory}
							auth
						/>

						<PrivateRoute path={`${BaseURL}/listcustomer`} component={ListCustomer} auth />
						<PrivateRoute path={`${BaseURL}/profile`} component={Profile} auth />
						<PrivateRoute path={`${BaseURL}/customer/:cusid`} component={CustomerDetail} auth />
					</Switch>
				</MainLayout>
			</Router>
		)
	}
}

function mapStateToProps(state) {
	const { alert } = state
	return {
		alert,
	}
}

export default connect(mapStateToProps)(App)
